import { render, staticRenderFns } from "./ScrollFixedHeader.vue?vue&type=template&id=58313a82&scoped=true&"
import script from "./ScrollFixedHeader.vue?vue&type=script&lang=js&"
export * from "./ScrollFixedHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58313a82",
  null
  
)

export default component.exports